module.exports = __webpack_public_path__ + "img/loading.2b98e730.gif";